import classNames from 'classnames';
import React from 'react';

import styles from './ButtonRow.module.scss';

export interface Props extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode;
}

const ButtonRow = (props: Props) => {
  return (
    <div {...props} className={classNames(styles.buttonRow, props.className)}>
      {props.children}
    </div>
  );
};

ButtonRow.Left = (props: Props) => {
  return (
    <div {...props} className={classNames(styles.left, props.className)}>
      {props.children}
    </div>
  );
};
ButtonRow.Right = (props: Props) => {
  return (
    <div {...props} className={classNames(styles.right, props.className)}>
      {props.children}
    </div>
  );
};

export default ButtonRow;
